export const CAMPAIGN_ORIGINS = {
  CREATED: "Created",
  INTERNAL: "Internal",
  PARTNER: "Partner",
};
